import SortIcon from "@redotech/redo-icons/switch-vertical-01_filled.svg";
import { Step } from "@redotech/redo-return-core-common/return-flow";
import { sortFromModel } from "@redotech/redo-return-core-common/return-flow-step-from-model";
import {
  isSortStepValid,
  SortState,
} from "@redotech/redo-return-core-common/return-flow-step-valid";
import { STEP_TYPE_NAMES } from "@redotech/redo-return-core-common/return-flow/step-type-names";
import { BlockLayout } from "@redotech/redo-web/flowchart";
import { produce } from "immer";
import * as React from "react";
import { StepType, StepTypeDetailsProps } from "../step";

export const SORT = (
  Details: React.ComponentType<StepTypeDetailsProps<SortState>>,
): StepType<SortState, Step.Sort> => ({
  Details: (props) => React.createElement(Details, props),
  customTitle: (state) => state.customTitle,
  description: (state) => (state.destination ? `→ ${state.destination}` : ""),
  downstream(state) {
    return state.next ? [{ id: state.next }] : [];
  },
  empty: { destination: "", scope: "return" },
  fromModel: (model, id) => sortFromModel(model, id),
  Icon: SortIcon,
  iconColor: "brand",
  layout: () => BlockLayout.FULL,
  maxDownstream: () => 1,
  removeConnection(state, targetStepId) {
    return produce(state, (draft) => {
      if (draft.next === targetStepId) {
        draft.next = undefined;
      }
    });
  },
  stepDeleted(state, stepId) {
    return produce(state, (draft) => {
      if (draft.next === stepId) {
        draft.next = undefined;
      }
    });
  },
  title: STEP_TYPE_NAMES[Step.SORT],
  toModel(state, id) {
    return {
      type: Step.SORT,
      customTitle: state.customTitle,
      destination: state.destination,
      next: state.next ? id(state.next) : null,
      scope: state.scope,
    };
  },
  updateConnection(state, handleIndex, targetStepId) {
    if (handleIndex !== 0) {
      throw new Error(`Invalid handle index ${handleIndex} for sort step`);
    }
    return produce(state, (draft) => {
      draft.next = targetStepId;
    });
  },
  valid: (state) => isSortStepValid(state).valid,
});
